export class ClienteClase {
    
    public id_cia: number;
    public tipdoc: number;
    public clase: number;
    public desclase: string;
    public codigo: number;
    public descodigo: string;
    public codcli: string;
}